// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signin-new-password-recovery-panel__container {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    gap: var( --grid-gap );
    grid-template-areas: "left left left left right right right right right right right right";
    background-color: var( --white-color );
    height: 125vh;
}

.signin-new-password-recovery-panel__container__left-col {
    grid-area: left;
    background-color: var( --primary-very-dark-color );
    height: 125vh;
}

.signin-new-password-recovery-panel__container__right-col {
    grid-column: 7 / 12;
    margin-top: calc( var( --space-x3 ) + var( --space-and-half) - 2px);
}

.signin-new-password-recovery-panel__title {
    font-family: var( --primary-font );
    font-style: normal;
    font-weight: 600;
    font-size: calc( var( --space-and-half ) + var( --space-quarter ) + 2px );
    line-height: calc( var( --space-x2 ) + var( --space-quarter ) );
    display: flex;
    align-items: center;
    color: var( --primary-very-dark-color );
    justify-content: center;
}

.signin-new-password-recovery-panel__text {
    margin: var( --space-x3 ) 0 calc( var( --space-x2 ) + var( --space-quarter) ) 0;
    font-family: Roboto; /* TODO change to var */
    font-style: normal;
    font-weight: 500;
    font-size: calc( var( --space ) + 3px );
    line-height: calc( var( --space-and-half ) - 2px );
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var( --primary-dark-color );
}

.signup-email-form__fields .input-field {
    margin: var( --space-half ) 0 var( --space-x2 ) 0;
}

.signup-email-form__fields .input-field .input-field-input {
    background: #ECECEC; /* TODO change to var */
    border-radius: var( --space-half );
}

.signin-new-password-recovery-panel__form__submit {    
    border-radius: calc( var( --space-half ) - 2px);
}

.signin-new-password-recovery-panel__form__submit .primary-button {
    background-color: #30B36B; /* TODO change to var */
    float: right;
}

.signin-new-password-recovery-panel__form__submit .primary-button span {
    text-transform: capitalize;
    font-family: Roboto; /* TODO change to var */
    font-style: normal;
    font-weight: 500;
    font-size: calc( var( --space ) + 3px );
    line-height: calc( var( --space-and-half ) - 2px );
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var( --white-color );
}

.signup-email-form__label {
    font-family: Roboto; /* TODO change to var */
    font-style: normal;
    font-weight: 500;
    font-size: calc( var( --space ) + 3px );
    line-height: calc( var( --space-and-half ) - 2px );
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var( --primary-dark-color );
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/components/signin-new-password-recovery-panel/SignInNewPasswordRecoveryPanelComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sCAAsC;IACtC,wBAAwB;IACxB,sBAAsB;IACtB,0FAA0F;IAC1F,sCAAsC;IACtC,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kDAAkD;IAClD,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,mEAAmE;AACvE;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,yEAAyE;IACzE,+DAA+D;IAC/D,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,uBAAuB;AAC3B;;AAEA;IACI,+EAA+E;IAC/E,mBAAmB,EAAE,uBAAuB;IAC5C,kBAAkB;IAClB,gBAAgB;IAChB,uCAAuC;IACvC,kDAAkD;IAClD,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,kCAAkC;AACtC;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,mBAAmB,EAAE,uBAAuB;IAC5C,kCAAkC;AACtC;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,yBAAyB,EAAE,uBAAuB;IAClD,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB,EAAE,uBAAuB;IAC5C,kBAAkB;IAClB,gBAAgB;IAChB,uCAAuC;IACvC,kDAAkD;IAClD,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB,EAAE,uBAAuB;IAC5C,kBAAkB;IAClB,gBAAgB;IAChB,uCAAuC;IACvC,kDAAkD;IAClD,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,kCAAkC;AACtC","sourcesContent":[".signin-new-password-recovery-panel__container {\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n    grid-template-rows: auto;\n    gap: var( --grid-gap );\n    grid-template-areas: \"left left left left right right right right right right right right\";\n    background-color: var( --white-color );\n    height: 125vh;\n}\n\n.signin-new-password-recovery-panel__container__left-col {\n    grid-area: left;\n    background-color: var( --primary-very-dark-color );\n    height: 125vh;\n}\n\n.signin-new-password-recovery-panel__container__right-col {\n    grid-column: 7 / 12;\n    margin-top: calc( var( --space-x3 ) + var( --space-and-half) - 2px);\n}\n\n.signin-new-password-recovery-panel__title {\n    font-family: var( --primary-font );\n    font-style: normal;\n    font-weight: 600;\n    font-size: calc( var( --space-and-half ) + var( --space-quarter ) + 2px );\n    line-height: calc( var( --space-x2 ) + var( --space-quarter ) );\n    display: flex;\n    align-items: center;\n    color: var( --primary-very-dark-color );\n    justify-content: center;\n}\n\n.signin-new-password-recovery-panel__text {\n    margin: var( --space-x3 ) 0 calc( var( --space-x2 ) + var( --space-quarter) ) 0;\n    font-family: Roboto; /* TODO change to var */\n    font-style: normal;\n    font-weight: 500;\n    font-size: calc( var( --space ) + 3px );\n    line-height: calc( var( --space-and-half ) - 2px );\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var( --primary-dark-color );\n}\n\n.signup-email-form__fields .input-field {\n    margin: var( --space-half ) 0 var( --space-x2 ) 0;\n}\n\n.signup-email-form__fields .input-field .input-field-input {\n    background: #ECECEC; /* TODO change to var */\n    border-radius: var( --space-half );\n}\n\n.signin-new-password-recovery-panel__form__submit {    \n    border-radius: calc( var( --space-half ) - 2px);\n}\n\n.signin-new-password-recovery-panel__form__submit .primary-button {\n    background-color: #30B36B; /* TODO change to var */\n    float: right;\n}\n\n.signin-new-password-recovery-panel__form__submit .primary-button span {\n    text-transform: capitalize;\n    font-family: Roboto; /* TODO change to var */\n    font-style: normal;\n    font-weight: 500;\n    font-size: calc( var( --space ) + 3px );\n    line-height: calc( var( --space-and-half ) - 2px );\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var( --white-color );\n}\n\n.signup-email-form__label {\n    font-family: Roboto; /* TODO change to var */\n    font-style: normal;\n    font-weight: 500;\n    font-size: calc( var( --space ) + 3px );\n    line-height: calc( var( --space-and-half ) - 2px );\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var( --primary-dark-color );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
